module.exports = require("optimize-css-assets-webpack-plugin");